"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { buttonVariants } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const capabilities = [{
  title: "MIL-SPEC Phenolic & Metal Nameplates",
  description: "Equipment nameplates and data plates in engraving-grade phenolic and metal, produced to align with MIL-SPEC nameplate standards such as MIL-DTL-15024 and MIL-P-15035 when specified — for shipboard, marine, and aerospace equipment.",
  linkText: "MIL-SPEC phenolic",
  linkUrl: "/products/mil-spec-phenolic/"
}, {
  title: "Direct Part Marking (DPM) & IUID",
  description: "Permanent 2D data matrix, serial numbers, and unique item identifiers (UII) marked directly on metal parts, designed to align with MIL-STD-130 item marking and AS9132 data matrix quality when specified — for traceability over the life of the component.",
  linkText: "Direct part marking",
  linkUrl: "/services/laser-marking-direct-part/"
}];
const supportingLinks = [];
export default function MilSpecNameplatesAndDpm() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: chipsRef,
    isVisible: isChipsVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section id="mil-spec-nameplates-and-dpm" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div ref={headerRef} className={cn("max-w-3xl mb-12 transition-all duration-700 ease-out", isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h2 className="font-default text-3xl md:text-4xl font-bold tracking-tight mb-4">
            What Does Evermark Produce for Marine and Aerospace?
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Two marking capabilities cover most marine and aerospace OEM
            requirements:
          </p>
        </div>

        <div ref={gridRef} className={cn("grid md:grid-cols-2 gap-6 md:gap-8 mb-12 transition-all duration-700 delay-100 ease-out", isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          {capabilities.map((capability, index) => <Card key={index} data-index={index} className="flex flex-col h-full border-border/50 shadow-sm hover:shadow-md transition-shadow duration-300">
              <CardHeader>
                <CardTitle className="font-default text-xl md:text-2xl">
                  <Link to={capability.linkUrl} className="hover:text-primary transition-colors">
                    {capability.title}
                  </Link>
                </CardTitle>
              </CardHeader>
              <CardContent className="flex-grow">
                <p className="text-muted-foreground leading-relaxed">
                  {capability.description}
                </p>
              </CardContent>
              <CardFooter>
                
              </CardFooter>
            </Card>)}
        </div>

        <div ref={chipsRef} className={cn("flex flex-wrap gap-3 items-center transition-all duration-700 delay-200 ease-out", isChipsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4")}>
          {supportingLinks.map((link, index) => <Badge key={index} data-index={index} variant="outline" asChild className="px-4 py-1.5 text-sm hover:bg-secondary hover:text-secondary-foreground transition-colors cursor-pointer">
              <Link to={link.url}>{link.text}</Link>
            </Badge>)}
        </div>
      </div>
    </section>;
}